import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  reservationView: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(7, "days").format("YYYY-MM-DD"),
    search_text: "",
    booking_status: 0,
    booking_source: 0,
    search_in_booking: 0,
    ota_source: 0,
    booking_type: 0,
  },
  calenderView: {
    initialDate: moment().format("YYYY-MM-DD"),
    perMonth: 7
  },
  overViewCalender: {
    initialDate: moment().format("YYYY-MM-DD"),
    perMonth: 7
  },
  otaOverviewCalender: {
    initialDate: moment().format("YYYY-MM-DD"),
    perMonth: 7,
    ota: [],
    otaCodeList: [],
  },
  nightReportList: false,
  nightReportDate: moment(localStorage.getItem("NightReportDate") || moment()).format("YYYY-MM-DD"),
 
};
const filterSlice = createSlice({
  name: "filters",
  initialState: initialState,
  reducers: {
    reservationViewChange: (state, action) => {
      state.reservationView = action.payload;
    },
    reservationViewReset: (state, action) => {
      state.reservationView = {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(7, "days").format("YYYY-MM-DD"),
        search_text: "",
        booking_status: 0,
        booking_source: 0,
        search_in_booking: 0,
        ota_source: 0
      };
    },
    nightReportListSuccess: (state, action) => {
        state.nightReportList = true;
        state.nightReportDate = action.payload;
      },
    nightReportListFailed: (state, action) => {
        state.nightReportList = false;
      },
    calenderViewChange: (state, action) => {
      state.calenderView = action.payload;
    },
    overViewCalenderChange: (state, action) => {
      state.overViewCalender = action.payload;
    },
    otaOverviewCalenderChange: (state, action) => {
      state.otaOverviewCalender = action.payload;
    },
  },
});

export const {
  reservationViewChange,
  reservationViewReset,
  nightReportListSuccess,
  nightReportListFailed,
  calenderViewChange,
  overViewCalenderChange,
  otaOverviewCalenderChange

} = filterSlice.actions;
export default filterSlice.reducer;